module.exports = __webpack_public_path__ + "img/cover3.fc52ffd4.png";